var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatSendIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0H18C25.732 0 32 6.26801 32 14V18C32 25.732 25.732 32 18 32H14C6.26801 32 0 25.732 0 18V14Z",
    fill: "#D2042D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4795 21.65C17.5017 21.7052 17.5402 21.7524 17.59 21.7851C17.6397 21.8178 17.6982 21.8345 17.7577 21.833C17.8172 21.8314 17.8748 21.8117 17.9228 21.7765C17.9708 21.7413 18.0068 21.6923 18.0261 21.636L21.8178 10.5527C21.8365 10.501 21.84 10.445 21.8281 10.3914C21.8161 10.3378 21.7891 10.2886 21.7503 10.2498C21.7114 10.2109 21.6623 10.1839 21.6086 10.172C21.555 10.16 21.4991 10.1636 21.4474 10.1822L10.364 13.9739C10.3078 13.9932 10.2587 14.0293 10.2235 14.0773C10.1883 14.1252 10.1686 14.1828 10.1671 14.2423C10.1656 14.3018 10.1823 14.3604 10.215 14.4101C10.2477 14.4598 10.2948 14.4983 10.35 14.5205L14.9759 16.3755C15.1221 16.434 15.255 16.5216 15.3665 16.6329C15.4779 16.7442 15.5657 16.8769 15.6245 17.023L17.4795 21.65Z",
    stroke: "white",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7479 10.252L15.3662 16.633",
    stroke: "white",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSendIcon);
export default __webpack_public_path__ + "static/media/chat-send-icon.5dff88c300aeaeb20bb9d42714006c8f.svg";
export { ForwardRef as ReactComponent };